import { useHistory } from 'react-router';
import { ELSTokenHelper } from '@els/els-ui-common-react';
import { AppContextState } from './AppProvider.component';
import { RoutePath } from './app.constants';
import { addSearchParams } from '../../utilities/app.utilities';
import { ELSTokenUser } from '../../models/els.dtos';
import { putRefreshTokenAction, trackNewRelicAction } from './app-state-actions.utilities';
import { clearAllTokens, storeTokens } from '../../utilities/token-manager.utilities';
import { notifyParentOfSessionExpired } from './app-session.utilities';
import { NewRelicAnalyticsAction } from '../../models/new-relic-analytics.models';

export const rotateRefreshTokenOrTimeout = (
  refreshToken: string,
  {
    setAppState,
    appStateRef,
    history,
  }: {
    setAppState: AppContextState['setAppState'];
    appStateRef: AppContextState['appStateRef'];
    history: ReturnType<typeof useHistory>;
  }
): Promise<void> => {
  return putRefreshTokenAction({
    setAppState,
    appStateRef,
    appState: appStateRef.current,
    refreshToken
  })
    .then((response) => {
      const tokenUser: ELSTokenUser = ELSTokenHelper.getUserInfoFromToken(response.eolsToken);
      if (!tokenUser?.userId) {
        throw new Error('Rotated token missing userId');
      }
      storeTokens(response);
      trackNewRelicAction({
        appStateRef,
        actionProps: { action: NewRelicAnalyticsAction.REFRESH_TOKEN_ROTATION_SUCCESS, props: null }
      });
      history.push(addSearchParams(`${RoutePath.LOGIN}/${tokenUser.userId}`, {
        courseId: tokenUser?.appParams?.courseId,
      }));
    })
    .catch((error) => {
      trackNewRelicAction({
        appStateRef,
        actionProps: {
          action: NewRelicAnalyticsAction.REFRESH_TOKEN_ROTATION_FAILED,
          props: { errorMessage: error?.message || String(error) }
        }
      });
      clearAllTokens();
      notifyParentOfSessionExpired();
      history.push(RoutePath.TIMEOUT);
    });
};
